const data = {
  title: "Floor 1-2",
  musicTrack: "MUSIC_WORLD1",
  theme: "BLUE",
  tilesWidth: 9,
  tilesHeight: 3,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 2,
      y: 2,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 8,
      y: 2,
    },
    {
      type: "WALL",
      x: 5,
      y: 2,
    },
    {
      type: "CHIP",
      x: 6,
      y: 3,
    },
    {
      type: "CHIP",
      x: 4,
      y: 1,
    },
  ],
};

export default data;
